// Thai
export const th = {
  'app.name':           'Kardolive',
  'app.tagline':        'พอร์ทัลลูกค้า',
  'app.signOut':        'ออกจากระบบ',

  'login.email':        'อีเมล',
  'login.password':     'รหัสผ่าน',
  'login.signIn':       'เข้าสู่ระบบ',
  'login.signingIn':    'กำลังเข้าสู่ระบบ…',
  'login.failed':       'เข้าสู่ระบบไม่สำเร็จ',
  'login.newAccount':   'ใหม่บน Kardolive?',
  'login.createAccount':'สร้างบัญชีฟรี →',

  'nav.workspace':      'พื้นที่ทำงาน',
  'nav.templates':      'เทมเพลต',
  'nav.live':           'ถ่ายทอดสด',
  'nav.rooms':          'ห้องและแชต',
  'nav.content':        'เนื้อหา',
  'nav.developer':      'ผู้พัฒนา',
  'nav.account':        'บัญชี',

  'nav.overview':       'ภาพรวม',
  'nav.projects':       'โปรเจ็กต์',
  'nav.chat':           'คอนโซลแชท',
  'nav.sessions':       'เซสชัน',
  'nav.streams':        'สตรีมสด',
  'nav.studio':         'สตูดิโอ',
  'nav.recordings':     'การบันทึก',
  'nav.apiKeys':        'คีย์ API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'เครื่องทดสอบ Webhook',
  'nav.networkTest':    'ทดสอบเครือข่าย',
  'nav.embed':          'วิดเจ็ตฝัง',
  'nav.sdk':            'SDK และเอกสาร',
  'nav.docs':           'เอกสารนักพัฒนา',
  'nav.analytics':      'การวิเคราะห์',
  'nav.settings':       'การตั้งค่า',

  'overview.welcome':       'ยินดีต้อนรับกลับ, {name}',
  'overview.plan':          '{tenant} · แผน {plan}',
  'overview.newStream':     'สตรีมใหม่',
  'overview.kpi.live':           'ออกอากาศตอนนี้',
  'overview.kpi.live.broadcasting': 'สตรีมกำลังออกอากาศ',
  'overview.kpi.live.nothing':    'ไม่มีออกอากาศ',
  'overview.kpi.total':           'สตรีมทั้งหมด',
  'overview.kpi.total.sub':       'ตลอดเวลา',
  'overview.kpi.sessions':        'เซสชั่น · 30 วัน',
  'overview.kpi.sessions.sub':    'เหตุการณ์เผยแพร่',
  'overview.kpi.recordings':      'การบันทึก',
  'overview.kpi.recordings.sub':  'พร้อมเล่น',
  'overview.recentStreams':       'สตรีมล่าสุด',
  'overview.recentSessions':      'เซสชั่นล่าสุด',
  'overview.viewAll':             'ดูทั้งหมด →',
  'overview.empty.title':         'ยังไม่มีสตรีม',
  'overview.empty.body':          'สร้างสตรีมแรกของคุณเพื่อเริ่มออกอากาศ',
  'overview.empty.action':        'สร้างสตรีม',
  'overview.noSessions':          'ยังไม่มีเซสชั่น',

  'status.live':        'ออกอากาศ',
  'status.idle':        'ว่าง',
  'status.ended':       'จบแล้ว',
  'status.archived':    'เก็บถาวร',

  'common.save':        'บันทึก',
  'common.cancel':      'ยกเลิก',
  'common.delete':      'ลบ',
  'common.edit':        'แก้ไข',
  'common.create':      'สร้าง',
  'common.confirm':     'ยืนยัน',
  'common.loading':     'กำลังโหลด…',
  'common.error':       'ข้อผิดพลาด',
  'common.retry':       'ลองอีกครั้ง',

  // Dashboard navigation and account controls.
  "nav.skipContent": "ข้ามไปยังเนื้อหาของหน้า",
  "nav.streamTemplates": "เทมเพลตการถ่ายทอดสด",
  "nav.boards": "กระดานโต้ตอบ",
  "nav.menu": "เปิดเมนูนำทาง",
  "nav.closeMenu": "ปิดเมนูนำทาง",
  "nav.scenarios": "รูปแบบการใช้งาน",
  "nav.premieres": "การฉายรอบปฐมทัศน์",
  "nav.clips": "คลิป",
  "dashboard.account": "บัญชี",
  "dashboard.language": "ภาษา",
  "dashboard.appearance": "รูปลักษณ์",
  "nav.allStreams": "การถ่ายทอดสดทั้งหมด",
  "nav.destinations": "ปลายทาง",
  "nav.ecommerce": "อีคอมเมิร์ซ",
  "nav.products": "สินค้า",
  "nav.services": "บริการ",
  "nav.collections": "คอลเลกชัน",
  "nav.orders": "คำสั่งซื้อ",
  "nav.commerceSettings": "การตั้งค่าการค้า",
  "nav.engagement": "การมีส่วนร่วม",
  "theme.light": "เปลี่ยนเป็นโหมดสว่าง",
  "theme.dark": "เปลี่ยนเป็นโหมดมืด",
  "role.owner": "เจ้าของ",
  "role.admin": "ผู้ดูแลระบบ",
  "role.member": "สมาชิก",
  "role.viewer": "ผู้ชม",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "ใช้งานอยู่",
  "streams.archived": "เก็บถาวรแล้ว",
  "streams.monitor": "ตรวจสอบแหล่งสัญญาณ",
  "streams.create": "สร้างการถ่ายทอดสด",
  "streams.list": "รายการ",
  "streams.grid": "ตาราง",
  "streams.view": "รูปแบบการแสดงรายการ",
  "streams.searchLabel": "ค้นหากิจกรรม",
  "streams.searchHint": "ค้นหาชื่อกิจกรรม",
  "streams.solutionFilter": "กรองกิจกรรมตามประเภท",
  "streams.statusFilter": "กรองกิจกรรมตามสถานะ",
  "streams.dateFilter": "กรองตามวันที่สร้าง",
  "streams.allSolutions": "ทุกประเภท",
  "streams.custom": "การตั้งค่าเดิมหรือกำหนดเอง",
  "streams.allStatuses": "ทุกสถานะ",
  "streams.anyTime": "ทุกวันที่สร้าง",
  "streams.last7": "สร้างใน 7 วันที่ผ่านมา",
  "streams.last30": "สร้างใน 30 วันที่ผ่านมา",
  "streams.count": "แสดง {shown} จาก {total} กิจกรรม",
  "streams.noMatch": "ไม่มีกิจกรรมที่ตรงกับตัวกรอง",
  "streams.clearFilters": "ล้างตัวกรอง",
  "streams.refreshFailed": "อัปเดตรายการไม่ได้",
  "streams.loadFailed": "โหลดการถ่ายทอดสดไม่ได้",
  "streams.stale": "กำลังแสดงรายการที่โหลดล่าสุด สถานะอาจเปลี่ยนไปแล้ว",
  "streams.connectionHint": "ตรวจสอบการเชื่อมต่อแล้วโหลดรายการใหม่",
  "streams.retrying": "กำลังลองใหม่…",
  "streams.retry": "ลองอีกครั้ง",
  "streams.restoreFailed": "กู้คืนการถ่ายทอดสดไม่ได้",
  "streams.restoreHint": "ตรวจสอบการเชื่อมต่อและอัปเดตรายการเพื่อดูสถานะล่าสุดก่อนลองใหม่",
  "streams.unused": "การถ่ายทอดสดที่ยังไม่เคยใช้: {count}",
  "streams.unusedHint": "ยังไม่มีการออกอากาศหรือวิดีโอย้อนหลัง เก็บถาวรเพื่อจัดรายการโดยไม่มีการลบข้อมูล",
  "streams.reviewArchive": "ตรวจสอบและเก็บถาวร",
  "streams.loading": "กำลังโหลดการถ่ายทอดสด…",
  "streams.archiveEmpty": "ยังไม่มีรายการที่เก็บถาวร การถ่ายทอดสดและวิดีโอย้อนหลังจะอยู่ที่นี่จนกว่าจะกู้คืน",
  "streams.restore": "กู้คืน",
  "streams.firstTitle": "สร้างการถ่ายทอดสดครั้งแรก",
  "streams.firstBody": "เลือกการตั้งค่าสำหรับการขาย ชั้นเรียน หรือบริการ หรือเริ่มจากแบบว่าง ถ่ายทอดสดผ่านเบราว์เซอร์ โทรศัพท์ หรือ OBS ได้",
  "streams.blank": "การถ่ายทอดสดแบบว่าง",
  "streams.broadcasts": "การออกอากาศ: {count}",
  "streams.replays": "วิดีโอย้อนหลัง: {count}",
  "streams.sessions": "เซสชัน: {count}",
  "streams.recordings": "การบันทึก: {count}",
  "streams.mode.BROADCAST": "ออกอากาศ",
  "streams.mode.LOW_LATENCY": "ความหน่วงต่ำ",
  "streams.mode.REALTIME": "เรียลไทม์",
  "streams.key": "คีย์",
  "streams.archiveTitle": "เก็บการถ่ายทอดสดที่ยังไม่เคยใช้ไว้ถาวร",
  "streams.archiveHint": "รายการเหล่านี้ยังไม่เคยออกอากาศ กู้คืนได้ทุกเมื่อจากแท็บเก็บถาวรแล้ว",
  "streams.archiveFailed": "เก็บถาวรไม่ได้ {count} รายการ อาจเริ่มถ่ายทอดสดแล้ว รายการอื่นเก็บถาวรเรียบร้อย",
  "streams.archiving": "กำลังเก็บถาวร…",
  "streams.archiveCount": "เก็บถาวร {count} รายการ",
  "streamType.webinar": "เว็บบินาร์ธุรกิจและงานเปิดตัว",
  "streamType.classroom": "ห้องเรียนและการสอนพิเศษ",
  "streamType.training": "การฝึกอบรมองค์กร",
  "streamType.conference": "การประชุมและนิทรรศการ",
  "streamType.shopping": "ช้อปปิ้งไลฟ์",
  "streamType.auction": "ประมูลไลฟ์",
  "streamType.consultation": "ปรึกษาส่วนตัว",
  "streamType.creator": "ไลฟ์ครีเอเตอร์และชุมชน",
  "streamType.audio": "ห้องเสียงและพอดแคสต์",
  "streamType.sports": "กีฬาและอีสปอร์ต",
  "streamType.performance": "คอนเสิร์ตและการแสดง",
  "streamType.community": "กิจกรรมศาสนาและการระดมทุน",
  "streamType.tour": "ทัวร์และการสาธิต",
  "streamType.fitness": "ฟิตเนสและเวิร์กช็อป",
  "streamType.public-meeting": "ข่าวและการประชุมสาธารณะ",
  "streamType.continuous": "ช่องต่อเนื่องและกล้อง",
  "streams.close": "ปิด",
};
